import { render, staticRenderFns } from "./stucompare.vue?vue&type=template&id=51778eb6&scoped=true"
import script from "./stucompare.vue?vue&type=script&lang=js"
export * from "./stucompare.vue?vue&type=script&lang=js"
import style0 from "./stucompare.vue?vue&type=style&index=0&id=51778eb6&prod&scoped=scoped&lang=css"
import style1 from "./stucompare.vue?vue&type=style&index=1&id=51778eb6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51778eb6",
  null
  
)

export default component.exports